// extracted by mini-css-extract-plugin
export default {"tupacGrid":"ok-z","tupacHeader":"pk-z","tupacHeader2":"qk-z","tupacMenu":"rk-z","tupacMenu2":"sk-z","tupacMain":"tk-z","tupacMain2":"uk-z"};